import axiosInstance from "./baseUrl";

// Fetch all marketer earnings
export const getMarketerEarningsService = async (params?: any) => {
  const response = await axiosInstance.get(`/v1/auth/marketer_earnings`, { params });
  return response.data;
};

// Fetch marketer earning summary
export const getMarketerEarningSummaryService = async (params?: any) => {
  const response = await axiosInstance.get(`/v1/auth/marketer_earnings_summary`, {
    params,
  });
  return response.data;
};
